import { ValuesOf } from '../utils/typeUtils';
import { SKINS } from './SidebarDividerNext.constants';

export interface SidebarDividerNextProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Indicates whether to remove the margin from sides */
  fullWidth?: boolean;
}

export type SidebarDividerNextSkin = ValuesOf<typeof SKINS>;
